import { createFeatureSelector, createSelector } from '@ngrx/store';
import { AutomationDetailsState } from './automation-details.reducer';

export const selectAutomationDetailsState = createFeatureSelector<AutomationDetailsState>('automationDetails');

export const selectAutomationDetails = createSelector(
  selectAutomationDetailsState,
  (state: AutomationDetailsState) => state.automation
);

export const selectAutomationDetailsLoading = createSelector(
  selectAutomationDetailsState,
  (state: AutomationDetailsState) => state.loading
);

export const selectAutomationDetailsError = createSelector(
  selectAutomationDetailsState,
  (state: AutomationDetailsState) => state.error
);

export const selectAutomationDocuments = createSelector(
  selectAutomationDetails,
  automation => automation?.documents || []
);

export const selectAutomationSettings = createSelector(selectAutomationDetails, automation => automation?.settings);

export const selectAutomationForm = createSelector(selectAutomationDetails, automation =>
  automation?.forms.filter(form => form.is_master)
);

export const selectHasDraftDocuments = createSelector(selectAutomationDocuments, documents =>
  documents.some(document => document.status_doc === 'DRAFT')
);
